<template>
    <v-dialog v-model="isActive" width="690" transition="dialog-bottom-transition" scrollable
        :fullscreen="$vuetify.breakpoint.mobile">
        <v-card class="rounded-0">
            <v-card flat class="rounded-0">
                <v-app-bar flat color="white" height="50" elevation="0">
                    <v-tooltip bottom>
                        <template v-slot:activator="{ on, attrs }">
                            <v-btn v-bind="attrs" v-on="on" icon @click.outside="cerrarDialogo"
                                @keydown.esc="cerrarDialogo">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </template>
                        <span>Cerrar</span>
                    </v-tooltip>
                    <v-toolbar-title>
                        <div class="text-h6 font-weight-bold primary--text">
                            {{ titulo }}
                        </div>
                    </v-toolbar-title>
                </v-app-bar>
            </v-card>
            <v-card class="rounded-0 align-center" flat>
                <v-card-text class="d-flex flex-column justify-center">
                    <v-row class="px-5">
                        <v-col cols="7" md="7" class="text-left">
                            <v-card-title class="font-weight-bold black--text text-h6">
                                Concepto
                            </v-card-title>
                            <v-card-text v-for="(item, index) in selectedItem.detalle" :key="index"
                                class="py-1 font-weight-regular text-body-1">
                                {{ item.descripcion }}
                            </v-card-text>
                        </v-col>
                        <v-col cols="5" md="5" class="text-end">
                            <v-card-title class="d-flex justify-end font-weight-bold black--text text-h6">
                                Importe
                            </v-card-title>
                            <v-card-text v-for="(item, index) in selectedItem.detalle" :key="index"
                                class="py-1 font-weight-regular text-body-1">
                                {{ formatMoney(item.monto) }}
                            </v-card-text>
                        </v-col>
                    </v-row>
                    <v-divider class="mx-4"></v-divider>
                    <v-row class="px-5">
                        <v-col cols="7" md="7">
                            <v-card-title class="font-weight-bold black--text text-body-1">
                                Total
                            </v-card-title>
                        </v-col>
                        <v-col md="5" cols="5">
                            <v-card-title class=" d-flex justify-end font-weight-bold black--text text-body-1">
                                {{formatMoney(selectedItem.detalle.reduce((sum, item) => sum + item.monto, 0))}}
                            </v-card-title>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
        </v-card>
    </v-dialog>
</template>

<script>

import { mapActions, mapGetters } from 'vuex'
import jsPDF from "jspdf";
import html2canvas from "html2canvas";

export default {
    name: 'DialogoDetallePago',

    components: {
    },
    data() {
        return {
            isActive: false,
            url: '',
            show: false,
            loading: false

        }
    },
    props: ['titulo', 'selectedItem'],

    computed: {

    },
    methods: {
        //...mapActions('auth', ['generarCredencialAfiliado', 'generarCredencialJubilado', 'generarConstanciaConvenios']),

        cerrarDialogo() {
            this.isActive = false
        },
        abrirDialogo() {
            this.isActive = true
        },
        formatMoney(value) {
            return value.toLocaleString('es-AR', { style: 'currency', currency: 'ARS' });
        },
        exportarPDF() {
            this.$nextTick(() => {
                this.loading = true;
                const elemento = this.$refs.contenido;

                if (!elemento) {
                    console.error("El elemento no está disponible en el DOM.");
                    return;
                }

                html2canvas(elemento, { scale: 1.2 }).then(canvas => {
                    const imgData = canvas.toDataURL("image/png");
                    const pdf = new jsPDF("p", "mm", "a4");

                    const pageWidth = pdf.internal.pageSize.getWidth(); // Ancho A4 (210mm)
                    const pageHeight = pdf.internal.pageSize.getHeight(); // Alto A4 (297mm)

                    const imgWidth = pageWidth - 90; // Margen de 20mm en cada lado
                    const imgHeight = (canvas.height * imgWidth) / canvas.width;

                    // Si la imagen es más alta que la página A4, se ajusta
                    let finalImgHeight = imgHeight;
                    let finalImgWidth = imgWidth;

                    if (imgHeight > pageHeight - 40) {
                        finalImgHeight = pageHeight - 40; // Ajusta altura dentro del A4
                        finalImgWidth = (canvas.width * finalImgHeight) / canvas.height;
                    }

                    const x = (pageWidth - finalImgWidth) / 2; // Centrar horizontalmente
                    const y = 10; // posicion a 10cm del borde superior

                    pdf.addImage(imgData, "PNG", x, y, finalImgWidth, finalImgHeight);
                    const referencia = this.selectedItem.mmp_referencia_externa.slice(-7);
                    pdf.save(`caja_de_psicologos_${referencia}.pdf`);
                }).catch(error => console.error("Error al generar el PDF:", error))
                    .finally(() => {
                        this.loading = false;
                    });
            });
        }

    }

}

</script>
